class GalleryLoadMore {
    constructor(passedElement) {
        this.elem = passedElement;
        this.grid = this.elem.querySelector('[data-gallery-grid]');
        this.btn = this.elem.querySelector('[data-gallery-load-more]');
        this.perPage = parseInt(this.elem.getAttribute('data-load-more-count')) || 6;
    }

    init() {
        if (!this.grid || !this.btn) return;

        const items = [...this.grid.children];

        if (items.length <= this.perPage) {
            this.btn.parentElement.classList.add('d-none');
            return;
        }

        items.forEach((item, i) => {
            if (i >= this.perPage) item.classList.add('is-hidden');
        });

        this.btn.addEventListener('click', () => {
            const hidden = [...this.grid.querySelectorAll('.is-hidden')];
            const toShow = hidden.slice(0, this.perPage);

            toShow.forEach((item) => item.classList.remove('is-hidden'));

            if (this.grid.querySelectorAll('.is-hidden').length === 0) {
                this.btn.parentElement.classList.add('d-none');
            }
        });
    }
}

export default GalleryLoadMore;
